import { render } from "./Main.vue?vue&type=template&id=6d3d5a86"
const script = {}
script.render = render

export default script